import React, { useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import axios from "axios";
import styled from "styled-components";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";

function App() {
  const [loginFormData, setLoginFormData] = useState({
    username: "",
    password: "",
  });
  const [loggedIn, setLoggedIn] = useState(false);
  const [keyadded, setKeyadded] = useState(0);
  const [dbres, setDbres] = React.useState([]);

  React.useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/get-keys`, {
        headers: {
          "x-api-key": process.env.REACT_APP_MASTER_API_KEY,
        },
      })
      .then((response) => {
        setDbres(response.data.reverse());
      })
      .catch((error) => {
        console.error(error);
      });
  }, [keyadded]);

  console.log("dbres", dbres);

  const addKey = () => {
    const newName = prompt("Enter name for the new key:");

    if (newName) {
      axios
        .post(
          `${process.env.REACT_APP_API_URL}/api/generate-key`,
          {
            name: newName,
          },
          {
            headers: {
              "x-api-key": process.env.REACT_APP_MASTER_API_KEY,
            },
          }
        )
        .then((response) => {
          console.log(response);
          setKeyadded(keyadded + 1);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      alert("Please provide name for the new key.");
    }
  };

  const revokeKey = (key: any) => {
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/revoke-key`,
        {
          apikey: key,
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_MASTER_API_KEY,
          },
        }
      )
      .then((response) => {
        console.log(response);
        setKeyadded(keyadded + 1);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleLogin = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/authenticate`,
        {
          username: loginFormData.username,
          password: loginFormData.password,
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_MASTER_API_KEY,
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          setLoggedIn(true);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const setCustomerNameAPI = (customerName: any, apiKey: any) => {
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/set-customer-name`,
        {
          customer_name: customerName,
          apikey: apiKey,
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_MASTER_API_KEY,
          },
        }
      )
      .then((response) => {
        console.log(response);
        setKeyadded(keyadded + 1);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const setStatusAPI = (apiKey: any, status: string) => {
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/set-status`,
        {
          apikey: apiKey,
          status: status,
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_MASTER_API_KEY,
          },
        }
      )
      .then((response) => {
        console.log(response);
        setKeyadded(keyadded + 1);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const setApiKeyScrapIn = (apikey_scrapin: any, apiKey: any) => {
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/set-scrapin-key`,
        {
          apikey_scrapin: apikey_scrapin,
          apikey: apiKey,
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_MASTER_API_KEY,
          },
        }
      )
      .then((response) => {
        console.log(response);
        setKeyadded(keyadded + 1);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const setWebhook = (webhook: any, apiKey: any) => {
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/set-webhook`,
        {
          webhook: webhook,
          apikey: apiKey,
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_MASTER_API_KEY,
          },
        }
      )
      .then((response) => {
        console.log(response);
        setKeyadded(keyadded + 1);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const submitApiKeyScrapeIn = (apikey_scrapin: any, apiKey: any) => {
    if (apikey_scrapin !== undefined) {
      setApiKeyScrapIn(apikey_scrapin, apiKey);
    }
  };

  const submitWebhook = (webhookurl: any, apiKey: any) => {
    if (webhookurl !== undefined) {
      setWebhook(webhookurl, apiKey);
    }
  };

  const submitCustomerName = (newCustomerName: any, apiKey: any) => {
    if (newCustomerName !== undefined) {
      setCustomerNameAPI(newCustomerName, apiKey);
    }
  };

  return (
    <Layout>
      {loggedIn ? (
        <AdminPortal>
          <div className="heading">
            <h1>LinkedIn Scraper</h1>{" "}
            <Button variant="contained" onClick={addKey}>
              Add Key
            </Button>
          </div>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell align="left">API Key</TableCell>
                  <TableCell align="left">API Key ScrapIn</TableCell>
                  <TableCell align="left">Webhook (Zoho Flow)</TableCell>
                  <TableCell align="left">Customer Name</TableCell>
                  <TableCell align="left">Total Hits</TableCell>
                  <TableCell align="left">Hits this month</TableCell>
                  <TableCell align="left">Status</TableCell>
                  <TableCell align="left">Revoke</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dbres?.map((res: any, index: any) => {
                  return (
                    <TableRow
                      key={res.id}
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {index + 1}
                      </TableCell>
                      <TableCell align="left">{res.api_key}</TableCell>
                      <TableCell align="left">
                        <div>
                          {res.api_key_scrapin}
                          <IconButton
                            onClick={() => {
                              const apikey_scrapin = prompt(
                                "Enter API key from ScrapeIn:"
                              );
                              if (apikey_scrapin !== null) {
                                submitApiKeyScrapeIn(
                                  apikey_scrapin,
                                  res.api_key
                                );
                              }
                            }}
                            style={{ marginLeft: "10px" }}
                          >
                            <EditIcon style={{ fontSize: "16px" }} />
                          </IconButton>
                        </div>
                      </TableCell>
                      <TableCell align="left">
                        <div>
                          {res.webhooks}
                          <IconButton
                            onClick={() => {
                              const webhookurl = prompt(
                                "Enter API key from ScrapeIn:"
                              );
                              if (webhookurl !== null) {
                                submitWebhook(webhookurl, res.api_key);
                              }
                            }}
                            style={{ marginLeft: "10px" }}
                          >
                            <EditIcon style={{ fontSize: "16px" }} />
                          </IconButton>
                        </div>
                      </TableCell>

                      <TableCell align="left">
                        <div>
                          {res.customer_name}
                          <IconButton
                            onClick={() => {
                              const newName = prompt("Enter new name:");
                              if (newName !== null) {
                                submitCustomerName(newName, res.api_key);
                              }
                            }}
                            style={{ marginLeft: "10px" }}
                          >
                            <EditIcon style={{ fontSize: "16px" }} />
                          </IconButton>
                        </div>
                      </TableCell>
                      <TableCell align="left">{res.hits}</TableCell>
                      <TableCell align="left">{res.hits_this_month}</TableCell>
                      <TableCell align="left">
                        <TextField
                          select
                          value={res.status}
                          onChange={(e) =>
                            setStatusAPI(res.api_key, e.target.value)
                          }
                        >
                          <MenuItem value="No Premium">No Premium</MenuItem>
                          <MenuItem value="Premium">Premium</MenuItem>
                        </TextField>
                      </TableCell>
                      <TableCell align="left">
                        <Button
                          variant="contained"
                          onClick={() => {
                            if (
                              window.confirm(
                                "Are you sure you want to delete this key?"
                              )
                            )
                              revokeKey(res.api_key);
                          }}
                          color="error"
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </AdminPortal>
      ) : (
        <Container component="main" maxWidth="xs">
          {/* <CssBaseline /> */}
          <LoginBox>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography component="h1" variant="h5">
                Log in
              </Typography>
              <form onSubmit={handleLogin}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="UserId"
                  label="UserId"
                  name="UserId"
                  onChange={(e) =>
                    setLoginFormData({
                      ...loginFormData,
                      username: e.target.value,
                    })
                  }
                  autoFocus
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  onChange={(e) =>
                    setLoginFormData({
                      ...loginFormData,
                      password: e.target.value,
                    })
                  }
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Log In
                </Button>
              </form>
            </Box>
          </LoginBox>
        </Container>
      )}
    </Layout>
  );
}

const Layout = styled.div`
  min-height: 100vh;
`;

const AdminPortal = styled.div`
  background: #fff;
  padding: 30px;
  border: 1px solid #ccc;
  border-radius: 26px;
  width: 80vw;
  max-width: 1200px;
  margin: auto;
  margin-top: 80px;
  .heading {
    background: linear-gradient(to top, #5d6dc3, #3c86d8);
    color: #fff;
    padding: 12px 20px;
    border-radius: 10px;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    margin-bottom: 14px;
    h1 {
      font-size: 22px;
    }
  }
`;
const LoginBox = styled.div`
  background: #fff;
  padding: 30px;
  border: 1px solid #ccc;
  border-radius: 26px;
  margin-top: 80px;
`;

export default App;
